import { render, staticRenderFns } from "./courseGoodsDetail.vue?vue&type=template&id=2b08b182&scoped=true"
import script from "./courseGoodsDetail.vue?vue&type=script&lang=js"
export * from "./courseGoodsDetail.vue?vue&type=script&lang=js"
import style0 from "./courseGoodsDetail.vue?vue&type=style&index=0&id=2b08b182&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b08b182",
  null
  
)

export default component.exports